// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "button.quickadd{outline:2px solid transparent;outline-offset:2px}button.quickadd:hover{background-color:transparent}", ""]);
// Exports
module.exports = exports;
